// interaction.ts
export const interactionTokens = {
  "interaction": {
    "hoverOpacity": {
      "value": 0.08,
      "type": "opacity",
      "filePath": "design-tokens/interaction.json",
      "isSource": true,
      "original": {
        "value": 0.08,
        "type": "opacity"
      },
      "name": "InteractionHoverOpacity",
      "attributes": {
        "category": "interaction",
        "type": "hoverOpacity"
      },
      "path": [
        "interaction",
        "hoverOpacity"
      ]
    },
    "focusOpacity": {
      "value": 0.12,
      "type": "opacity",
      "filePath": "design-tokens/interaction.json",
      "isSource": true,
      "original": {
        "value": 0.12,
        "type": "opacity"
      },
      "name": "InteractionFocusOpacity",
      "attributes": {
        "category": "interaction",
        "type": "focusOpacity"
      },
      "path": [
        "interaction",
        "focusOpacity"
      ]
    },
    "pressedOpacity": {
      "value": 0.12,
      "type": "opacity",
      "filePath": "design-tokens/interaction.json",
      "isSource": true,
      "original": {
        "value": 0.12,
        "type": "opacity"
      },
      "name": "InteractionPressedOpacity",
      "attributes": {
        "category": "interaction",
        "type": "pressedOpacity"
      },
      "path": [
        "interaction",
        "pressedOpacity"
      ]
    },
    "disabledOpacity": {
      "value": 0.38,
      "type": "opacity",
      "filePath": "design-tokens/interaction.json",
      "isSource": true,
      "original": {
        "value": 0.38,
        "type": "opacity"
      },
      "name": "InteractionDisabledOpacity",
      "attributes": {
        "category": "interaction",
        "type": "disabledOpacity"
      },
      "path": [
        "interaction",
        "disabledOpacity"
      ]
    }
  }
} as const;

export type InteractionTokens = typeof interactionTokens;
